import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { promise } from 'protractor';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private endpoint = environment.endpoint;
  private url = this.endpoint;
  isAuthenticate: boolean = false;
  
  constructor(private httpclient: HttpClient,
    private router: Router) { }

  getUserInfo(token) {
    return new Promise(resolve => {
      const url = this.url + '/user/current-user';
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        })
      };
      this.httpclient.get(url, httpOptions)
        .subscribe(response => {
          if (response["success"]) {
            resolve(response)
          }
        }, err => {
          // // console.log("logout app auth token expired", err.error.errors);
          err.error.errors.base.forEach(item => {
            if (item === 'jwt expired' || item === 'jwt malformed') {
              //logout web app
              this.isAuthenticate = false
              this.router.navigate(['/login'])
            }
          });
          resolve(false)
        })
    })
  }

}
